import React, {useEffect, useState} from 'react';
import {InfiniteScroll, PullToRefresh, List, Ellipsis, NavBar, SwipeAction, Dialog, Empty} from 'antd-mobile';
import { AddCircleOutline, } from 'antd-mobile-icons';
import {useNavigate} from "react-router-dom";
import {deleteSecret, getSecretList} from "../../services/secret";
import toast from "../../utils/toast";
import response from "../../utils/response";

import './list.css';

const SecretList = () => {
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const perPage = 15;

    function getData(isRefresh) {
        setHasMore(false);

        getSecretList({
            page: isRefresh ? 1 : page,
            per_page: perPage
        }).then(res => {
            const {code, data} = res || {};

            if (response.isSuccess(code)) {
                setHasMore(data.current_page < data.last_page);

                if (isRefresh) {
                    setPage(2);
                    setList(data.data);
                } else {
                    setPage(() => data.current_page + 1);
                    setList(val => [...val, ...data.data]);
                }
            }
        });
    }

    useEffect(() => {
        getData(true);
        // eslint-disable-next-line
    }, []);

    const toAddPage = () => {
        navigate('/secret/add');
    };
    
    const navBarRight = (
        <div style={{ fontSize: 24 }}>
            <AddCircleOutline onClick={toAddPage} />
        </div>
    );

    const handleClick = (id) => {
        navigate('/secret/details/' + id);
    };

    function handleDelete(id) {
        Dialog.confirm({
            content: '确定要删除吗？',
            onConfirm: async () => {
                deleteSecret(id).then(res => {
                    const {code} = res || {};

                    if (response.isSuccess(code)) {
                        toast.success('删除成功');

                        const newList = list.filter(item => item.id !== id);
                        setList(newList);
                    }
                });
            },
        });
    }

    return (
        <div className="page-container">
            <div className="page-top" onClick={()=>{}}>
                <NavBar
                    backArrow={false}
                    right={navBarRight}
                >
                    秘密
                </NavBar>
            </div>
            <div className="page-body page-bg">
                <PullToRefresh
                    onRefresh={() => getData(true)}
                >
                    {list.length > 0 ? (
                        <>
                            <List>
                                {list.map(item => (
                                    <SwipeAction
                                        key={item.id}
                                        rightActions={[
                                            {
                                                key: 'delete',
                                                text: '删除',
                                                color: 'danger',
                                                onClick: () => handleDelete(item.id),
                                            },
                                        ]}
                                    >
                                        <List.Item
                                            key={item.id}
                                            description={item.create_time}
                                            onClick={() => handleClick(item.id)}
                                        >
                                            <Ellipsis direction='end' content={item.title} />
                                        </List.Item>
                                    </SwipeAction>
                                ))}
                            </List>
                            <InfiniteScroll loadMore={() => getData(false)} hasMore={hasMore} />
                        </>
                    ) : (
                        <List>
                            <Empty
                                style={{ padding: '64px 0' }}
                                description='暂无数据'
                            />
                        </List>
                    )}
                </PullToRefresh>
            </div>
        </div>
    )
};

export default SecretList;